import { AutoshipmentLogoMark, ButtonAnchor, H4 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import React from 'react';
import styles from './PreviouslyOrdered.module.scss';
import { LastEligibleOrderInfo } from '../../model/order';
import { useSiteContext } from '@zooplus/commons-lang';
import { Trans } from 'react-i18next';
import { AmountLabel } from '../common/amount-label/AmountLabel';
import { MiniProductsList } from '../common/mini-products-list/MiniProductsList';
import { BoxWithCta } from '../common/box-with-cta/BoxWithCta';

interface PreviouslyOrderedProps {
  lastEligibleOrderInfo: LastEligibleOrderInfo;
}

export const PreviouslyOrdered = (props: PreviouslyOrderedProps) => {
  const { t } = useTranslation();
  const { site } = useSiteContext();

  const content = (
    <div className={styles.orderInfo}>
      <H4 className={styles.sentence}>
        <Trans
          i18nKey={'previously-ordered.save'}
          components={{
            savings: (
              <AmountLabel
                amount={props.lastEligibleOrderInfo.offer.totalAutoshipmentDiscount}
                currency={props.lastEligibleOrderInfo.offer.currency}
                amountFormatted={props.lastEligibleOrderInfo.offer.totalAutoshipmentDiscountFormatted}
              />
            ),
          }}
          t={t}
        />
      </H4>
      <MiniProductsList
        products={props.lastEligibleOrderInfo.offer.articles}
        hasAnchor={true}
        orderId={props.lastEligibleOrderInfo.offer.orderId}
      />
    </div>
  );

  const buttons = [
    <ButtonAnchor
      id={`convert-to-subscription-${props.lastEligibleOrderInfo.offer.orderId}`}
      key={`convert-to-subscription-${props.lastEligibleOrderInfo.offer.orderId}`}
      data-zta={'convert-to-subscription'}
      href={props.lastEligibleOrderInfo.url}
      size={'normal'}
      length={'full'}
      variant={'primary'}
      className={styles.convertButton}>
      <AutoshipmentLogoMark realm={site.realm} className={styles.icon} />
      {t('previously-ordered.convert-button')}
    </ButtonAnchor>,
  ];

  return <BoxWithCta titleKey={'previously-ordered.title'} content={content} buttons={buttons} />;
};
